import { render, staticRenderFns } from "./primary-impersonation.vue?vue&type=template&id=5adc2c06&"
import script from "./primary-impersonation.vue?vue&type=script&lang=js&"
export * from "./primary-impersonation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports